export const years = [
  2000, 2001, 2002, 2003, 2004,
  2005, 2006, 2007, 2008, 2009,
  2010, 2011, 2012, 2013, 2014,
  2015, 2016, 2017, 2018, 2019,
  2020, 2021, 2022, 2023, 2024,
  2025, 2026, 2027, 2028, 2029
]

export const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

export const macro = [
  { name: 'pi', value: '3.14159' },
  { name: 'e', value: '2.71828' },
  { name: 'year', value: '2017' },
  { name: 'currency1', value: '4.0' },
  { name: 'currency2', value: '0.8' },
]
